import React, { useState } from "react";
import {
    Box,
    Grid,
    FormControl,
    Tooltip,
    IconButton,
    Typography,
    Divider,
} from "@mui/material";

import Backicon from "@mui/icons-material/ArrowBack";  // replace with your custom import
import Saveicon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import Approveicon from "@mui/icons-material/CheckCircle";
import Amendicon from "@mui/icons-material/Edit";
import Printicon from "@mui/icons-material/Print";

const DespatchActionMenu = ({
    isVisible,
    fromModule,
    headerText,
    btnSaveUpdate,
    btnSaveTooltip,
    btnSaveText,
    btnCancel,
    btnApprove,
    btnAmendment,
    btnPrint,
    handleBack,
    handleSave,
    handleCancel,
    handleApprove,
    handleAmendment,
    handlePrint,
}) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);

        if (buttonName === 'back') {
            handleBack();
        }
        else if (buttonName === 'save') {
            handleSave(true);
        }
        else if (buttonName === 'cancel') {
            // handleCancel();
        }
        else if (buttonName === 'approve') {
            // handleApprove();
        }
        else if (buttonName === 'ament') {
            // handleAmendment();
        }

        else if (buttonName === 'print') {
            handlePrint();
        }

    };
    if (!isVisible) return null;



    return (




        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Grid container justifyContent="space-between" alignItems="center" padding={0}>

                {/* Left-aligned: Edit Employee */}
                <Grid item>
                    <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                        {/* {title === 0 ? 'New Employee' : 'Edit Employee'} */}
                        {headerText}
                        {/* New Order */}
                    </Typography>
                </Grid>

                <Grid item>
                    <Grid container alignItems="center">
                        <>
                            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            {/* Save */}
                            <Grid item ml={1} mr={1}>
                                <Tooltip title={`Back to ${fromModule} [ALT + B]`}>
                                    <IconButton
                                        onClick={() => handleButtonClick('back')}
                                        sx={{ display: 'flex', alignItems: 'center' }}

                                    // disabled={saveButtonDisabled}
                                    >
                                        <Backicon style={{ fontSize: "18px", color: selectedButton === 'back' ? "yellow" : "#009688" }} />
                                        <Typography variant="body2" sx={{ ml: 1 }}>Back</Typography>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                        {btnSaveUpdate && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title={btnSaveTooltip}>
                                        <IconButton
                                            onClick={() => handleButtonClick('save')}
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <Saveicon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Save</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}
                        {btnCancel && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Cancel Plan">
                                        <IconButton
                                            onClick={(e) =>{handleButtonClick('cancel'); handleCancel('Cancel Plan');} }
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <CancelIcon style={{ fontSize: "18px", color: selectedButton === 'cancel' ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Cancel</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {btnApprove && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Approve Plan">
                                        <IconButton
                                            onClick={(e) => { handleButtonClick('approve'); handleApprove('Approve Plan'); }}
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <Approveicon style={{ fontSize: "18px", color: selectedButton === 'approve' ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Approve</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {btnAmendment && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Amend Plan">
                                        <IconButton
                                            onClick={(e) => { handleButtonClick('ament'); handleAmendment('Amend Plan'); }}
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <Amendicon style={{ fontSize: "18px", color: selectedButton === 'ament' ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Ament</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}

                        {btnPrint && (
                            <>
                                <Grid item ml={1} mr={1}>
                                    <Tooltip title="Amend Plan">
                                        <IconButton
                                            onClick={(e) => { handleButtonClick('print') }}
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <Printicon style={{ fontSize: "18px", color: selectedButton === 'print' ? "yellow" : "#009688" }} />
                                            <Typography variant="body2" sx={{ ml: 1 }}>Print</Typography>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                            </>
                        )}









                    </Grid>
                </Grid>




            </Grid>
            <Divider />
        </Box>


        // <Box>
        //   {/* Top Action Buttons */}
        //   <Box m="0px" display="flex" justifyContent="space-between">
        //     <Grid ml={1} container spacing={0} mb={0}>
        //       {/* Back Button */}
        //       <Grid item md={0} mr={1}>
        //         <FormControl fullWidth>
        //           <Tooltip title={`Back to ${fromModule} [ALT + B]`}>
        //             <IconButton onClick={handleBack}>
        //               <Backicon style={{ color: "#2196F3" }} />
        //             </IconButton>
        //           </Tooltip>
        //           <Typography align="center" fontSize={11}>
        //             Back
        //           </Typography>
        //         </FormControl>
        //       </Grid>

        //       {/* Save */}
        //       {btnSaveUpdate && (
        //         <Grid item md={0} mr={1}>
        //           <FormControl fullWidth>
        //             <Tooltip title={btnSaveTooltip}>
        //               <IconButton onClick={handleSave}>
        //                 <Saveicon style={{ color: "#388e3c" }} />
        //               </IconButton>
        //             </Tooltip>
        //             <Typography align="center" fontSize={11}>
        //               {btnSaveText}
        //             </Typography>
        //           </FormControl>
        //         </Grid>
        //       )}

        //       {/* Cancel */}
        //       {btnCancel && (
        //         <Grid item md={0} mr={1}>
        //           <FormControl fullWidth>
        //             <Tooltip title="Cancel Plan">
        //               <IconButton onClick={handleCancel}>
        //                 <CancelIcon style={{ color: "#ef5350" }} />
        //               </IconButton>
        //             </Tooltip>
        //             <Typography align="center" fontSize={11}>
        //               Cancel
        //             </Typography>
        //           </FormControl>
        //         </Grid>
        //       )}

        //       {/* Approve */}
        //       {btnApprove && (
        //         <Grid item md={0} mr={1}>
        //           <FormControl fullWidth>
        //             <Tooltip title="Approve Plan">
        //               <IconButton onClick={handleApprove}>
        //                 <Approveicon style={{ color: "#26a69a" }} />
        //               </IconButton>
        //             </Tooltip>
        //             <Typography align="center" fontSize={11}>
        //               Approve
        //             </Typography>
        //           </FormControl>
        //         </Grid>
        //       )}

        //       {/* Amendment */}
        //       {btnAmendment && (
        //         <Grid item md={0} mr={1}>
        //           <FormControl fullWidth>
        //             <Tooltip title="Amend Plan">
        //               <IconButton onClick={handleAmendment}>
        //                 <Amendicon style={{ color: "#f06292" }} />
        //               </IconButton>
        //             </Tooltip>
        //             <Typography align="center" fontSize={11}>
        //               Amend
        //             </Typography>
        //           </FormControl>
        //         </Grid>
        //       )}

        //       {/* Print */}
        //       {btnPrint && (
        //         <Grid item md={0} mr={1}>
        //           <FormControl fullWidth>
        //             <Tooltip title="Print">
        //               <IconButton onClick={handlePrint}>
        //                 <Printicon style={{ color: "#689f38" }} />
        //               </IconButton>
        //             </Tooltip>
        //             <Typography align="center" fontSize={11}>
        //               Print
        //             </Typography>
        //           </FormControl>
        //         </Grid>
        //       )}
        //     </Grid>
        //   </Box>

        //   <Divider style={{ marginBottom: "1px" }} />

        //   {/* Header */}
        //   <Box
        //     m="10px"
        //     display="flex"
        //     justifyContent="space-between"
        //     mt={1}
        //     mb={1}
        //     alignItems="top"
        //   >
        //     <Typography variant="h4" fontWeight="bold">
        //       {headerText}
        //     </Typography>
        //   </Box>
        // </Box>
    );
};

export default DespatchActionMenu;
